import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import { Box, Tooltip, Typography } from "@mui/material";
import useColors from "../../../../../../api/hooks/useColors";
import TextIntegrationStyle from "../../TextIntegrationStyle";

const ServerCodeRepositoryView = ({ entityData }) => {
  const colors = useColors();

  return (
    <Box display={"flex"} flexDirection={"column"} gap={2} marginBottom={5}>
      {entityData?.ox_data?.app_link && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Name</Typography>
          </Box>
          <Box ml={2} display={"flex"} alignItems={"center"} gap={1}>
            <TextIntegrationStyle
              title={""}
              value={entityData.ox_data.app_link.replace(/^https?:\/\//, "")}
            ></TextIntegrationStyle>
            <Tooltip title="Open link in new tab">
              <a
                href={entityData.ox_data.app_link}
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: "flex", alignItems: "center" }}
              >
                <OpenInNewRoundedIcon
                  sx={{ width: "12px", color: colors.action_active }}
                />
              </a>
            </Tooltip>
          </Box>
        </Box>
      )}
      {entityData?.ox_data?.deployed_prod && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>
              Deployed In Production
            </Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData.ox_data.deployed_prod ? "Yes" : "No"}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.ox_data?.is_public && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Public</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData.ox_data.is_public ? "Yes" : "No"}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.ox_data?.creator && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Creator</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData.ox_data.creator}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.ox_data?.languages && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Languages</Typography>
          </Box>
          <Box ml={3} display={"flex"} flexDirection={"column"} gap={1}>
            {Object.entries(entityData.ox_data.languages).map(
              ([language, percentage], index) => (
                <TextIntegrationStyle
                  key={index}
                  title={language}
                  value={`${percentage}%`}
                />
              )
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ServerCodeRepositoryView;
